import { call, put, all, takeLatest } from 'redux-saga/effects';

import { apiTransacao } from '~/services/api';

import { successRecebimentos, failureRecebimentos } from './actions';

function* requestRecebimentos({ payload }) {
	const { params } = payload;
	try {
		const resposta = yield call(
			apiTransacao.get,
			`recebimentos-cliente/${params}`
		);

		const dados = {
			dados: resposta.data,
			lista: resposta.data.recebimentos ? resposta.data.recebimentos : [],
		};

		delete dados.dados.recebimentos;

		yield put(successRecebimentos(dados));
	} catch (error) {
		yield put(failureRecebimentos(error.response.status));
	}
}

export default all([
	takeLatest('@clientRecebimentos/REQUEST', requestRecebimentos),
]);
